import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CallState } from '@lcs/shared/api';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { getCurrentUserIsSystemUser } from 'src/app/authentication/state/authentication.selector';
import { Detail } from 'src/app/common-components/detail/detail';
import { FormsBase } from 'src/app/common-components/forms-base/forms-base';
import { getDevicePrivileges } from 'src/app/privileges/privileges.selector';
import { DeviceRegisterListItem } from '../../device-register/models/device-register-results.model';
import { rebootPhone, resetPhoneZtp } from '../../device-register/state/device-register.actions';
import { DeviceDetailSaveEvent } from '../models/device-detail-form-submit-event';
import { DeviceDetailView } from '../models/device-detail-view.model';
import { DevicePrivileges } from '../models/device-privileges';
import { DeviceDetailFormService } from '../services/device-detail-form.service';
import * as DeviceDetailActions from '../state/device-detail.actions';
import { changeSipUserPasswords } from '../state/device-detail.actions';
import { getDevice, getDeviceCallState } from '../state/device-detail.selectors';

@Component({
    encapsulation: ViewEncapsulation.None,
    host: { class: 'entity-detail' },
    providers: [DeviceDetailFormService, { provide: FormsBase, useExisting: DeviceDetailFormService }],
    selector: 'ndt-device-detail',
    templateUrl: './device-detail.component.html',
    standalone: false
})
export class DeviceDetailComponent extends Detail<DeviceDetailFormService> implements OnDestroy {
   device$: Observable<DeviceDetailView | null>;

   callState$: Observable<CallState>;

   devicePrivileges$: Observable<DevicePrivileges>;

   constructor(public store: Store, private router: Router, formService: DeviceDetailFormService) {
      super(store, formService);
      this.device$ = this.store.pipe(select(getDevice));
      this.callState$ = this.store.pipe(select(getDeviceCallState));
      this.devicePrivileges$ = this.store.pipe(select(getDevicePrivileges));
      this.isSystemUser$ = this.store.pipe(select(getCurrentUserIsSystemUser));
      this.store.dispatch(DeviceDetailActions.deviceDetailLoad());
   }

   ngOnInit(): void {
      this.router.events.pipe(takeUntil(this.destroyed$)).subscribe((e) => {
         if (e instanceof NavigationEnd) {
            this.store.dispatch(DeviceDetailActions.deviceDetailLoad());
         }
      });
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   onFormSaveCanceled(): void {
      this.store.dispatch(DeviceDetailActions.deviceDetailCancel());
   }

   onFormSubmitted(event: DeviceDetailSaveEvent): void {
      this.store.dispatch(DeviceDetailActions.saveDeviceDetail(event));
   }

   onDeviceReleased(event: DeviceDetailSaveEvent): void {
      this.store.dispatch(DeviceDetailActions.releaseDeviceDetail(event));
   }

   onReleaseToAccount(device: DeviceRegisterListItem): void {
      if (device.deviceId) {
         this.store.dispatch(DeviceDetailActions.releaseDeviceToAccount({ deviceId: device.deviceId }));
      }
   }

   onDeleteDevice(event: DeviceDetailSaveEvent): void {
      if (event.device.deviceId) {
         this.store.dispatch(DeviceDetailActions.deleteDevice({ deviceId: event.device.deviceId }));
      }
   }

   onRebootPhone(deviceId: number) {
      this.store.dispatch(rebootPhone({ deviceId: deviceId }));
   }

   onResetPhoneZtp(deviceId: number) {
      this.store.dispatch(resetPhoneZtp({ deviceId: deviceId }));
   }

   onResetHackedAndFraud(device: DeviceDetailView) {
      const hackedAndFraudSipUserIds = device.hackedAndFraudSipUserIds;

      if (
         hackedAndFraudSipUserIds !== null &&
         hackedAndFraudSipUserIds !== undefined &&
         hackedAndFraudSipUserIds.length > 0
      ) {
         this.store.dispatch(changeSipUserPasswords({ sipUserIds: hackedAndFraudSipUserIds }));
      }
   }
}
